import {AddressAttribute, AddressValidationRules, QuoteAddress} from '@/store/models';
import store from '@/store';
import {Validator} from 'vee-validate';

export default function getValidationRules(addressAttribute: AddressAttribute, address?: QuoteAddress) {
    const validator = new Validator();
    const validationRules: AddressValidationRules = {
        required: !!addressAttribute.validate,
    };

    switch (addressAttribute.code) {
        case 'fiscaleitalia_fiscalcode':
            validationRules.required = true;
            validationRules['validate-fiscal-code'] = true;
            break;

        case 'postcode':
            // eslint-disable-next-line no-case-declarations
            const countryId = address ? address.country_id : '';
            // eslint-disable-next-line no-case-declarations
            const postCodeDigits = store.state.options.countrysettings.zipdigits;

            if (store.state.options.store_code !== 'it_it') {
                validationRules.max = postCodeDigits;
                break;
            }

            validationRules.digits = countryId === 'CH' ? 4 : postCodeDigits;
            break;

        case 'region_id':
            validationRules.required = true;
            validationRules['validate-regionid'] = true;
            break;

        case 'telephone-without-prefix':
            if (store.state.options.store_code === 'it_it') {
                validationRules[`validate-${addressAttribute.code}`] = true;
            } else {
                validationRules[`validate-foreign-country-${addressAttribute.code}`] = true;
            }
            break;

        case 'vat_id':
            validationRules.required = true;
            validationRules['validate-vat-number'] = true;
            break;

        default:
            // eslint-disable-next-line no-case-declarations
            const validationRule = `validate-${addressAttribute.code}`;

            if (Object.keys(validator.rules).includes(validationRule)) {
                validationRules[validationRule] = true;
            }

            break;
    }

    return validationRules;
}
